import { render } from "./typeEdit.vue?vue&type=template&id=55d80364&scoped=true"
import script from "./typeEdit.vue?vue&type=script&lang=js"
export * from "./typeEdit.vue?vue&type=script&lang=js"

import "./typeEdit.vue?vue&type=style&index=0&id=55d80364&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d80364"],['__file',"src/views/active/components/typeEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55d80364"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55d80364', __exports__)) {
    console.log('reload')
    api.reload('55d80364', __exports__)
  }
  
  module.hot.accept("./typeEdit.vue?vue&type=template&id=55d80364&scoped=true", () => {
    console.log('re-render')
    api.rerender('55d80364', render)
  })

}


export default __exports__